<template>
  <v-col sm="12" class="stepper-wrapper">
    <v-stepper class="stepper col-md-8 col-12" v-model="$store.state.formPageNumber">
      <v-stepper-header>
        <v-stepper-step class="stepper-container" step="1" :color="stepperColor" :complete="$store.state.formPageNumber > 1"> </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step class="stepper-container" step="2" :color="stepperColor" :complete="$store.state.formPageNumber > 2"> </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step class="stepper-container" step="3" :color="stepperColor" :complete="$store.state.formPageNumber > 3"> </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step class="stepper-container" step="4" :color="stepperColor" :complete="$store.state.formPageNumber > 4"> </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step class="stepper-container" step="5" :color="stepperColor" :complete="$store.state.formPageNumber > 5"> </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step class="stepper-container" step="6" :color="stepperColor" :complete="$store.state.formPageNumber > 6"> </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step class="stepper-container" step="7" :color="stepperColor" :complete="$store.state.formPageNumber > 7"> </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
  </v-col>
</template>

<script>
export default {
  name: "Stepper",
  data: () => ({
    stepperColor: "#00A8C8",
  }),
};
</script>

<style scoped>
    .stepper-container span {
        min-width: 20px;
        width: 20px;
        height: 20px;
    }
</style>